export default __webpack_public_path__ + "static/media/Cera_Scaglie_Incenso_120x120.5ecda356.jpg";